export default "__VITE_ASSET__CwGaEJmP__"